import { motion } from 'framer-motion'

// Utils
import { pageVariants } from 'components/interestform/utils'

import commonStyles from 'components/interestform/slides/common.css'
import styles from './thisistracklib.css'

const ThisIsTracklib = (): JSX.Element => {
  return (
    <motion.div className={styles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <div className={styles.content}>
        <h1 className={commonStyles.heading}>This is Tracklib</h1>
        <div className={commonStyles.subheading}>
          Tracklib is an innovative platform for today’s producers and artists to discover and legally sample parts of original recordings
          into new songs
        </div>
        <div className={commonStyles.textContent}>
          <div className={commonStyles.paragraph}>
            Created by music lovers from Stockholm, we are a group of people with a vision to liberate creativity. In a short period of
            time, Tracklib has become the go-to service for everyone from bedroom DJ&apos;s to the world&apos;s top producers and artists
            looking for samples
          </div>
        </div>
      </div>

      <div className={styles.background}>
        <div>
          <img src="/static/images/interestform/record-half.jpg" alt="Record half" className={styles.backgroundImg} />
        </div>
        <div>
          <img src="/static/images/interestform/waveform.png" alt="Record Illustration" className={styles.backgroundImg} />
        </div>
      </div>
    </motion.div>
  )
}

export default ThisIsTracklib
